import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import ProductSearchScoreData from "@insite/content-library/Components/ProductSearchScoreData";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import ProductListProductInformation from "@insite/content-library/Widgets/ProductList/ProductListProductInformation";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import GuestProductListActions from "@WhiteCap/Widgets/GuestRFQ/GuestProductListActions";
import React, { FC} from "react";
import { css } from "styled-components";

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User

type Props = ProductCardSelections & HasProduct;

export interface ProductListProductCardStyles {
    gridContainer?: GridContainerProps;
    itemsMessageGridItem?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    actionsGridItem?: GridItemProps;
    actionsGridItemInner?: InjectableCss;
    searchScoreDataGridItem?: GridItemProps;
    sponsoredText?: TypographyPresentationProps;
}

export const productCardStyles: ProductListProductCardStyles = {
    itemsMessageGridItem: {
        gap: 0,
        css: css`
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        min-width: 242px;
                    `,
                    css`
                        min-width: 320px;
                    `,
                    css`
                        min-width: 320px;
                    `,
                    css`
                        min-width: 376px;
                    `,
                    css`
                        min-width: 376px;
                    `,
                ])}
            word-wrap: break-word !important;
            overflow-wrap: break-word !important;
        `,
    },
    gridContainer: {
        gap: 0,
        css: css`
            padding: 30px 0;
            min-width: 320px; /* prevent overlap with second column */
        `,
    },
    leftColumnGridItem: {
        width: [4, 4, 4, 3, 3],
        css: css`
            padding-right: 20px;
            flex-direction: column;
        `,
    },
    rightColumnGridItem: {
        width: [8, 8, 8, 9, 9],
    },
    infoGridItem: {
        width: [12, 12, 12, 7, 7],
        css: css`
            padding-bottom: 5px !important;
        `,
    },
    actionsGridItem: {
        width: [12, 12, 12, 5, 5],
    },
    searchScoreDataGridItem: {
        width: 12,
        css: css`
            padding: 5px !important;
        `,
    },
    sponsoredText: {
        css: css`
            margin-bottom: 5px;
            font-size: 0.9em;
            opacity: 0.5;
        `,
    },
    actionsGridItemInner:{
        css: css`
            width: 100%;
        `
    }
}

const styles = productCardStyles;

const GuestProductListProductCard: FC<Props> = props => {

    const SponsoredText = props.product.isSponsored ? (
        <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>
    ) : null;


    return (
        <div  className="product">
            <GridContainer {...styles.gridContainer} data-test-selector={`productListProductCard${props.product.id}`}>
                <GridItem {...styles.leftColumnGridItem}>
                    
                    {SponsoredText}

                    <ProductListProductImage
                        showImage={props.showImage}
                        showCompare={props.showCompare}
                        showImageBadge={props.showImageBadges}
                        showTextBadge={props.showTextBadges}
                    />
                </GridItem>
                <GridItem {...styles.rightColumnGridItem}>
                    <GridContainer {...styles.rightColumnGridContainer}>
                        <GridItem {...styles.infoGridItem}>
                            <ProductListProductInformation
                                showBrand={props.showBrand}
                                showTitle={props.showTitle}
                                showPartNumbers={props.showPartNumbers}
                                showAvailability={false}
                                showAttributes={props.showAttributes}
                                showImageBadges={props.showImageBadges}
                                maxImageBadges={props.maximumNumberOfImageBadges}
                                showTextBadges={props.showTextBadges}
                                maxTextBadges={props.maximumNumberOfTextBadges}
                            />
                        </GridItem>
                        <GridItem {...styles.actionsGridItem}>
                            <StyledWrapper {...styles.actionsGridItemInner}>
                                <GuestProductListActions
                                    showPrice={props.showPrice}
                                    showAddToList={props.showAddToList}
                                />
                            </StyledWrapper>
                        </GridItem>
                        <GridItem {...styles.searchScoreDataGridItem}>
                            <ProductSearchScoreData />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            </GridContainer>
        </div>
    );
};


export default withProduct(GuestProductListProductCard);

// EC-234 : SubTask - EC-282 = Creating a PLP variant for Guest User